import { dataFetch } from "@lib/ggj-utils";

export default {
	// 分页获取用户平台优惠券
	selectPlatformCouponPage(params) {
		return dataFetch(
			"/promotion/api/resource/selectPlatformCouponPage",
			params,
			{
				method: "post",
				// headers: { 'gj-ua': 4 }
			}
		);
	},
	// 分页获取历史用户优惠券
	selectHistoryCouponPage(params) {
		return dataFetch(
			"/promotion/api/resource/selectHistoryCouponPage",
			params,
			{
				method: "post",
				// headers: { 'gj-ua': 4 }
			}
		);
	},
	//导航栏是否展示课转赠标
	barshowIcon(params) {
		return dataFetch("/promotion/api/resource/canTransfer", params, {
			method: "post",
			// headers: { 'gj-ua': 4 }
		});
	},
	// 查询用户id
	selectId(params) {
		return dataFetch("/promotion/api/user/getUserById", params, {
			method: "post",
			// headers: { 'gj-ua': 4 }
		});
	},
	// 转赠接口
	submitInfo(params) {
		return dataFetch("/promotion/api/resource/transferBuyerResource", params, {
			method: "post",
			// headers: { 'gj-ua': 4 }
		});
	},
	// // 领券中心
	// getListCoupons (params) {
	//   return dataFetch('/coupon/center/listCoupons', params)
	// },
	// // 用户优惠券汇总
	// getAccountCouponSummary (params) {
	//   return dataFetch('/resource/getAccountCouponSummary', params, { prefixName: 'promotion' })
	// },
	// // 优惠码兑换
	// exchangeCoupon (params) {
	//   return dataFetch('/couponCode/exchangeCoupon', params, { prefixName: 'promotion' })
	// },
	// // 获取用户店铺优惠券
	// getAccountShopCoupon (params) {
	//   return dataFetch('/resource/getAccountShopCoupon', params, { prefixName: 'promotion' })
	// },
	// // 获取优惠券信息
	// getCouponById (params) {
	//   return dataFetch('/coupon/getCouponById', params, { prefixName: 'promotion' })
	// },
	// // 获取店铺基本信息
	// getShopBaseInfo (params) {
	//   return dataFetch('/shop/getShopBaseInfo', params, { prefixName: 'promotion' })
	// },
	// // 领取优惠券
	// receiveCoupon (params) {
	//   return dataFetch('/coupon/receiveCoupon', params, { prefixName: 'promotion' })
	// }
};
